import Servicios from "pages/LandingPages/Servicios/servicios";

export default function ServiciosPage() {
  return <Servicios />;
}
